import { Outlet, useNavigation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import FullSceenLoader from "@/components/molecules/FullSceenLoader";
import useAppStore from "@/stores/useAppStore";
// import { ThemeModeToggle } from "@/components/molecules/ThemeModeToggle";
function RootRouter() {
  const navigation = useNavigation();
  const isAppLoading = useAppStore((s) => s.isAppLoading);
  const showLoader = navigation.state === "loading" || isAppLoading;
  return (
    <div className="size-full">
      <ToastContainer position="bottom-right" />
      {showLoader && <FullSceenLoader />}
      <Outlet />
    </div>
  );
}

export default RootRouter;
